import request from '@/utils/request'
// 查询select Report
export const getReportTableData = params =>
  request.get('/fs/customer-api/company-finances-css/page', params)
// 查询chart&&表格数据
export const getMultipleData = params =>
  request.post(
    `/fs/customer-api/company-finances-analysis-css/finances-reports/manyTypes`,
    params,
  )
// 下载财务报告
export const downLoadSelectReport = params =>
  request.post(
    `/fs/customer-api/company-finances-analysis-css/downReports`,
    params,
    {
      responseType: 'blob',
    },
  )

// 根据某一个chart请求数据
export const getTheChart = params =>
  // 接口文档就这字段 compnayId
  request.post(
    `/fs/customer-api/company-finances-analysis-css/charts/getImage`,
    params,
  )

export const editData = params =>
  request.post(
    '/fs/customer-api/company-finances-analysis-css/finances-reports/updateFinanceReport',
    params,
  )
